import { render, staticRenderFns } from "./SalesChannel.vue?vue&type=template&id=f2cefba2&scoped=true"
import script from "./SalesChannel.vue?vue&type=script&lang=ts"
export * from "./SalesChannel.vue?vue&type=script&lang=ts"
import style0 from "./SalesChannel.vue?vue&type=style&index=0&id=f2cefba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cefba2",
  null
  
)

export default component.exports